import { Component } from '@angular/core';

@Component({
  template: `
    <main>
      <div class="row expanded">
        <div class="small-12 columns">
          <h1>Page Not Found</h1>
          <p>We&#8217;re sorry, that page does not exist.</p>
          <a routerLink="/">Home</a>
        </div>
      </div>
    </main>
  `
})
export class NoContentComponent {
  bodyClasses = 'error';
}
